import { getApp, getApps, initializeApp } from "firebase/app";

const FIREBASE_CONFIG_FIELDS = Object.freeze([
  ["apiKey", "REACT_APP_FIREBASE_API_KEY"],
  ["authDomain", "REACT_APP_FIREBASE_AUTH_DOMAIN"],
  ["projectId", "REACT_APP_FIREBASE_PROJECT_ID"],
  ["storageBucket", "REACT_APP_FIREBASE_STORAGE_BUCKET"],
  ["messagingSenderId", "REACT_APP_FIREBASE_MESSAGING_SENDER_ID"],
  ["appId", "REACT_APP_FIREBASE_APP_ID"],
]);

export const FIREBASE_VAPID_KEY_ENV = "REACT_APP_FIREBASE_VAPID_KEY";

let cachedFirebaseApp = null;

function normalizedEnvironmentValue(environment, name) {
  const value = environment?.[name];
  return typeof value === "string" ? value.trim() : "";
}

function readFirebasePublicConfig(environment) {
  return Object.fromEntries(
    FIREBASE_CONFIG_FIELDS.map(([field, environmentName]) => [
      field,
      normalizedEnvironmentValue(environment, environmentName),
    ])
  );
}

export function getFirebasePublicConfigStatus(environment = process.env) {
  const missingVariables = FIREBASE_CONFIG_FIELDS.filter(
    ([, environmentName]) =>
      !normalizedEnvironmentValue(environment, environmentName)
  ).map(([, environmentName]) => environmentName);
  const configured = missingVariables.length === 0;

  return {
    configured,
    code: configured ? null : "firebase_client_unconfigured",
    missingVariables,
    vapidConfigured: Boolean(
      normalizedEnvironmentValue(environment, FIREBASE_VAPID_KEY_ENV)
    ),
  };
}

export function getFirebaseClientApp(environment = process.env) {
  const status = getFirebasePublicConfigStatus(environment);
  if (!status.configured) return null;

  if (cachedFirebaseApp) return cachedFirebaseApp;

  const existingApps = getApps();
  const existingDefaultApp = existingApps.find(
    (app) => app?.name === "[DEFAULT]"
  );
  cachedFirebaseApp = existingDefaultApp
    ? getApp()
    : initializeApp(readFirebasePublicConfig(environment));
  return cachedFirebaseApp;
}

export function resetFirebaseClientForTests() {
  cachedFirebaseApp = null;
}
